import styled from 'styled-components';
import { Tooltip } from 'antd';

export const AntTootltip = styled(Tooltip)``;
